import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import {
    FetchMainIncomePayload,
    MainIncomeDetail,
    MainIncomeEndpoints,
    MainIncomeState,
} from './mainIncomeTypes';
import { initialStateMainIncome as initialState } from './mainIncomeStateDefaultValue';
import { ApiStatus } from '../../types';

const mainIncomeSlice = createSlice({
    name: 'mainIncome',
    initialState,
    reducers: {
        getMainIncome(state) {
            state.apiStatus = ApiStatus.Pending;
        },
        getMainIncomeFulfilled(
            state,
            action: PayloadAction<FetchMainIncomePayload>,
        ) {
            const { content, ...rest } = action.payload;

            state.content = JSON.parse(content);
            state.incomeDetails = {
                ...rest,
            };
            state.apiStatus = ApiStatus.Fulfilled;
        },
        getMainIncomeRejected(state) {
            state.apiStatus = ApiStatus.Rejected;
        },
        upsertMainIncome: (state, action: PayloadAction<MainIncomeDetail>) => state,
        upsertMainIncomeFulfilled(
            state,
            action: PayloadAction<MainIncomeDetail>,
        ) {

            state.incomeDetails = action.payload;
        },
        upsertMainIncomeRejected: (state) => state,

        updateMainIncomeEndPoints: (state, action: PayloadAction<MainIncomeEndpoints>) => {
            state.apiEndpoints = action.payload;
        },
        submitMainIncome: (state) => state,
        resetMainIncomeStatus(state) {
            state.apiStatus = ApiStatus.Idle;
        },
    },
});

export const {
    getMainIncome,
    getMainIncomeFulfilled,
    getMainIncomeRejected,
    upsertMainIncome,
    upsertMainIncomeFulfilled,
    upsertMainIncomeRejected,
    updateMainIncomeEndPoints,
    submitMainIncome,
    resetMainIncomeStatus,
} = mainIncomeSlice.actions;

export const mainIncomeReducer: Reducer<MainIncomeState, AnyAction> =
mainIncomeSlice.reducer;
